import i18n from '../i18n';

/**
 * Format a history timestamp for compact display:
 *  - same calendar day  → time only (e.g. "14:05" or "2:05 PM")
 *  - older              → "d/m/y H:i"
 * Respects the user's general time-format preference ('12h' | '24h').
 */
export function formatHistoryTime(timestamp, timeFormat) {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';

  const locale = i18n.language === 'de' ? 'de-DE' : 'en-US';
  const time = date.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: timeFormat === '12h',
  });

  const now = new Date();
  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();
  if (isToday) return time;

  const d = String(date.getDate()).padStart(2, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const y = date.getFullYear();
  return `${d}/${m}/${y} ${time}`;
}
